import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Button,
  Card,
  Divider,
  Modal,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Add, Save } from '@material-ui/icons';

import { upperFirst } from '../../../../util';
import styles from './styles';

const fields = ['Name', 'Longitude', 'Latitude'];
// we may want to make this consistent with the backend.
// things are still in progress for building the backend

class AddUniversityCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ..._.zipObject(fields, fields.map(() => '')),
      open: props.open,
      mode: props.mode,
    };
    this._handleCategory = this._handleCategory.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { open, mode } = nextProps;
    this.setState({ open, mode });
  }

  _handleCategory(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  renderTextFields(classes) {
    return (
      <div className={classes.textFieldContainer}>
        {
          fields.map(f => {
            return (
              <TextField
                id={f}
                key={f}
                label={upperFirst(f)}
                className={classNames(classes.textField, classes[`textField-${f}`])}
                margin="normal"
              />
            );
          })
        }
      </div>
    );
  }

  render() {
    const { onClose, classes } = this.props;
    const { open, mode } = this.state;
    return (
      <Modal
        aria-labelledby="Add Institution"
        aria-describedby="Input a new Institution and add it to the database"
        open={open}
        onClose={() => onClose('edit')}
      >
        <Card className={classes.card}>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="title" color="inherit">
                {upperFirst(mode)} an Institution
              </Typography>
            </Toolbar>
          </AppBar>
          {this.renderTextFields(classes)}
          <Divider />
          <div className={classes.buttonContainer}>
            <Button
              color="primary"
              variant="raised"
              className={classes.button}
            >
              {
                mode === 'add' &&
                <React.Fragment>
                  <Add className={classes.icon} />
                  Add Institution
                </React.Fragment>
              }
              {
                mode === 'edit' &&
                <React.Fragment>
                  <Save className={classes.icon} />
                  Save
                </React.Fragment>
              }
            </Button>
          </div>
        </Card>
      </Modal>
    );
  }
}

AddUniversityCard.propTypes = {
    classes: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['add', 'edit']).isRequired,

};

export default withStyles(styles)(AddUniversityCard);



// WEBPACK FOOTER //
// ./src/modules/universities/cards/AddUniversityCard/index.js